export default {
  Basic: 1,
  Full: 2,
};
